import { Avatar, Button, Dropdown, Navbar } from "flowbite-react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { auth } from "../../utils/firebase";
import { Link } from "react-router-dom";

function NavBar({ isLogin }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [user, setUser] = useState(null);
  
  // Check if profile completion is required
  const isProfileCompletionRequired = searchParams.get("complete") === "required" && location.pathname === "/student/my-profile";

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const userRole = user?.reloadUserInfo?.customAttributes
    ? JSON.parse(user?.reloadUserInfo?.customAttributes).role
    : null;

  const handleSignOut = () => {
    auth
      .signOut()
      .then(() => {
       
        localStorage.removeItem("idtoken");
        localStorage.removeItem("studentData");
        localStorage.removeItem("campusDetails");
        localStorage.removeItem("staffData");
        navigate("/login");
      })
      .catch((error) => {
        console.error("Sign out error:", error);
      });
  };

  const studentname = user?.displayName || user?.email || "";

  // Teams-like 5-color palette for initials avatar
  const colorPalette = [
    { bg: '#E3F2FD', fg: '#1E88E5' }, // light blue
    { bg: '#E8F5E9', fg: '#2E7D32' }, // light green
    { bg: '#FFF3E0', fg: '#EF6C00' }, // light orange
    { bg: '#EDE7F6', fg: '#6A1B9A' }, // light purple
    { bg: '#FCE4EC', fg: '#AD1457' }, // light pink
  ];
  const colorKey = (user?.displayName || user?.email || 'U') + '';
  const hash = Array.from(colorKey).reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  const palette = colorPalette[hash % colorPalette.length];
  const initials = ((user?.displayName && user.displayName) || (user?.email && user.email) || 'U')
    .replace(/[^A-Za-z0-9]/g, '')
    .slice(0, 2)
    .toUpperCase();
  

  return (
   <Navbar
  fluid
  className={`fixed top-0 z-30 items-center w-screen
    ${isLogin
      ? "bg-transparent border-transparent"
      : "bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700"}
  `}
>

      <Navbar.Brand href="/">
        <img
          src="/images/favicon-removebg-preview.png"
          className="mr-3 h-7 sm:h-9"
          alt="/images/favicon-removebg-preview.png"
        />
        <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white text-primary">
          Better Tomorrow
        </span>
      </Navbar.Brand>
      
      <div className="flex md:order-2 ">
        {isLogin && (
          <a
            href="/contactus"
            className="mr-10 font-semibold text-primary hover:text-indigo-500"
          >
            Contact Us
          </a>
        )}
        {!user ? (
          !isLogin ? (
            <Button href="/login" className="p-0 text-white bg-primary">
              Login
            </Button>
          ) : null
        ) : !isLogin && (
          <div className="flex items-center gap-3 md:order-2">
            {/* Get Help Button for Staff and Super Staff */}
            {(userRole === "staff" ) && (
              <button
                onClick={() => navigate("/staff-data-instruction")}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium transition-colors rounded-lg text-primary hover:text-indigo-600 hover:bg-indigo-50"
                title="Get Help"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                  />
                </svg>
                <span className="hidden sm:inline">Get Help</span>
              </button>
            )}
            
            <Dropdown
              arrowIcon={false}
              inline
              label={
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: palette.bg,
                    color: palette.fg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 400,
                    fontSize: 14,
                    userSelect: 'none',
                  }}
                  title={studentname}
                >
                  {initials}
                </div>
              }
            >
              <Dropdown.Header>
                <span className="block text-sm">
                  {user.displayName}
                  <span className="ml-1 font-light">({userRole})</span>
                </span>
                <span className="block text-sm font-medium truncate">
                  {user.email}
                </span>
              </Dropdown.Header>
              {/* <Dropdown.Item
                href={
                  userRole === "bt-admin" || userRole === "staff"
                    ? "/admin"
                    : "/student/assignments"
                }
              >
                Leaderboard
              </Dropdown.Item> */}
              {(userRole === "staff" || userRole === "student") && (
                <Link
                  to={
                    userRole === "staff"
                      ? "/staff/my-profile"
                      : "/student/my-profile"
                  }
                >
                  <Dropdown.Item>Profile</Dropdown.Item>
                </Link>
              )}
              {userRole === "student" && (
                <Link to={"/student/orders"}>
                  <Dropdown.Item>Orders</Dropdown.Item>
                </Link>
              )}

              <Dropdown.Item onClick={handleSignOut}>Sign out</Dropdown.Item>
            </Dropdown>
          </div>
        )}
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        {userRole === "student" && (
          <> */}
      {/* <Navbar.Link
              href="/"
              className={`${
                location.pathname === "/" ? "text-primary" : "text-gray-600"
              }`}
            >
              Home
            </Navbar.Link> */}
      {/* <Navbar.Link
              href="/student/courses"
              className={`${
                location.pathname.startsWith("/student/courses") ||
                location.pathname.startsWith("/student/courses")
                  ? "text-primary"
                  : "text-gray-600"
              }`}
            >
              Practice
            </Navbar.Link>
            <Navbar.Link
              href="/assignments"
              className={`${
                location.pathname.startsWith("/assignments") ||
                location.pathname.startsWith("/assignments")
                  ? "text-primary"
                  : "text-gray-600"
              }`}
            >
              Assignments
            </Navbar.Link> */}
      {/* </>
        )}
      </Navbar.Collapse> */}
    </Navbar>
  );
}

export default NavBar;
